<template>
    <div class="join_market_wrap"> 
        <el-dialog
        title="选择课程"
        :visible.sync="dialogValue"
        width="800px"
        custom-class="join_market_dialog"
        @close="handleClose">
        <div slot="title" style="display: flex; align-items: center">
            <span>选择课程</span>
            <p class="common-title">提示：该列表只显示已上架且有章节的课程</p>
        </div>
        <div class="join_market_table">
            <div class="gettinglist_table_search">
                <div class="gettinglist_table_search_con">
                    <el-input placeholder="请输入课程标题查询" v-model="keywords" class="gettinglist_input_tit">
                        <el-button slot="append" type="primary" @click="search">查询</el-button>
                    </el-input>
                </div>
            </div>
           <el-scrollbar style="height:500px" class="maket_scrollbar">
                <el-table :data="tableList" @row-click="rowClick" :header-cell-style="{background: '#F5F7FA',color:'#454D53'}">
                    <el-table-column label="" width="50">
                        <template slot-scope="scope">
                            <input type="radio" :checked="scope.row.id == selectId.id"/>
                        </template>
                    </el-table-column>product_type
                    <!-- <el-table-column property="product_type" label="类型" width="100"></el-table-column> -->
                    <el-table-column property="img" label="封面" width="200">
                        <template slot-scope="scope">
                            <img :src="scope.row.img" alt="" style="width:67px;height:50px"/>
                        </template>
                    </el-table-column>
                    <el-table-column property="title" label="标题" width="260"></el-table-column>
                    <el-table-column property="price" label="价格"></el-table-column>
                </el-table>
           </el-scrollbar>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="sure">确 定</el-button>
        </span>
        </el-dialog>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    props: {
        dialogValue: {
            type: Boolean,
            default: false
        }
    },
    model: {
        prop: 'dialogValue',
        event: 'change'
    },
    data() {
        return {
            dialogVisible: false,
            tableList: [],
            selectId: {},
            keywords:''
        }
    },
    created() {
        // this.getProductSelect()
    },
    methods: {
        ...mapActions('market', ['productSelect']),
        rowClick(row) {
            this.selectId = row
            console.log(row, 'pp')
        },
        handleClose() {
            this.$emit('change', false)
            this.keywords = ''
        },
        sure() {
            this.$emit('change', false)
            this.$emit('sure', this.selectId)
            this.keywords = ''
        },
        async getProductSelect() {
            let res = await this.productSelect({keywords:this.keywords})
            this.tableList = res.list
        },
        search(){
            this.getProductSelect()
        }
    },
    watch: {
        dialogValue(news) {
            console.log(news, '[[[')
            if(news) {
                this.getProductSelect()
            }
        }
    }
}
</script>
<style lang="less">
     .join_market_table {
        height: 600px;
         display: flex;
        flex-direction: column;
        overflow: hidden;
        padding-bottom: 56px;
        .maket_scrollbar {
            flex: 1 0 auto;
            height: 0;
        }
        .gettinglist_table_search {
            margin-bottom: 12px;
            display: flex;
            flex-wrap: wrap;
            flex-shrink: 0;
            .gettinglist_table_search_con {
                flex-shrink: 0;
            }
            .gettinglist_input_tit {
                .el-input-group__append, .el-input-group__prepend {
                    background-color: #409eff;
                    border-color: #409eff;
                    color: #fff;
                }
            }
        }
    }
</style>